import React, { useEffect, useState } from 'react';
import { useAuth } from '../AuthProvider';
import { useNavigate } from 'react-router-dom';
import './Interviews.css';
import { v4 as uuidv4 } from 'uuid';

// Helper function to parse dates
const parseDate = (dateField) => {
  if (dateField && dateField._seconds) {
    // Handle Firestore timestamp objects
    return new Date(dateField._seconds * 1000);
  } else if (dateField instanceof Date) {
    return dateField;
  } else if (typeof dateField === 'string') {
    return new Date(dateField);
  } else {
    console.error('Unexpected date format:', dateField);
    return null; // Return null for invalid dates
  }
};

const Interviews = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [interviews, setInterviews] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchInterviews = async () => {
      try {
        if (user) {
          const token = await user.getIdToken();
          const response = await fetch('http://localhost:4242/get-interviews', {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          if (response.ok) {
            const data = await response.json();
            console.log('Received interviews data:', data);

            // Sort the interviews array by date in descending order
            const sortedInterviews = (data.interviews || []).slice().sort((a, b) => {
              const dateA = parseDate(a.date).getTime();
              const dateB = parseDate(b.date).getTime();
              return dateB - dateA; // Most recent dates first
            });

            setInterviews(sortedInterviews);
          } else {
            const contentType = response.headers.get('content-type');
            if (contentType && contentType.includes('application/json')) {
              const errorData = await response.json();
              setError(`Failed to fetch interviews: ${errorData.error}`);
            } else {
              const errorText = await response.text();
              setError(`Failed to fetch interviews: ${response.statusText}`);
            }
          }
        } else {
          setError('User is not authenticated.');
        }
      } catch (err) {
        console.log('Error fetching interviews:', err);
        setError(`Error fetching interviews: ${err.message}`);
      }
    };

    fetchInterviews();
  }, [user]);

  return (
    <div className="interviews-container">
      <div className="interviews-header">
        <h2>Interview History</h2>
        <button className="start-new-button" onClick={() => navigate(`/interview/${uuidv4()}`)}>
          Start New
        </button>
      </div>
      {error ? (
        <div className="error-message">{error}</div>
      ) : (
        <div className="table-responsive">
          {interviews && interviews.length > 0 ? (
            <table className="interviews-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Time</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                {interviews.map((interview, index) => {
                  const date = parseDate(interview.date);

                  if (!date) {
                    return null; // Skip this interview if the date is invalid
                  }

                  const formattedDate = date.toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    timeZone: 'America/New_York',
                  });
                  const formattedTime = date.toLocaleTimeString('en-US', {
                    hour: 'numeric',
                    minute: 'numeric',
                    hour12: true,
                    timeZone: 'America/New_York',
                  });

                  return (
                    <tr key={index}>
                      <td>{formattedDate}</td>
                      <td>{formattedTime}</td>
                      <td>
                        <button onClick={() => navigate(`/interview-details/${interview.id}`)}>
                          Details
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <p>No interviews found.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default Interviews;